import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Menu = props => (
  <nav id="menu">
    <div className="inner">
      <ul className="links">
        <li>
          <Link onClick={props.onToggleMenu} to="/">
            ホーム
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/news">
            お知らせ
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/products">
            プロダクト
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/recruit">
            採用情報
          </Link>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/company">
            会社概要
          </Link>
        </li>
      </ul>
      <ul className="actions vertical">
        <li>
          <a href="/en" className="button special fit">
            English
          </a>
        </li>
      </ul>
    </div>
    <a className="close" onClick={props.onToggleMenu} href="javascript:;">
      Close
    </a>
  </nav>
)

Menu.propTypes = {
  onToggleMenu: PropTypes.func,
}

export default Menu
